export class ValidationError extends Error {
  constructor(
    public field: string,
    public message: string,
  ) {
    super(`Validation error on ${field}: ${message}`);

    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
